import { styled, theme } from "../../../../../../styles/stitches.config"

export const TableContainer = styled("div", {
  width: "100%",
  borderRadius: "19px",
  overflow: "hidden",
  border: `2px solid ${theme.colors.lines}`,
})

export const Tbody = styled("tbody", {
  height: "105px",
})

export const Table = styled("table", {
  borderCollapse: "collapse",
  width: "100%",
})

export const TableRow = styled("tr", {
  borderTop: `2px solid ${theme.colors.lines}`,
  "&:first-child": {
    borderTop: "none",
  },
})

export const TableData = styled("td", {
  borderRight: `2px solid ${theme.colors.lines}`,
  color: theme.colors.primary,
  width: theme.sizes.s25,
  paddingTop: theme.space.s5,
  paddingLeft: theme.space.s5_5,
  paddingRight: theme.space.s5_5,
  paddingBottom: theme.space.s5,
  textAlign: "start",
  fontSize: theme.sizes.s4,
  "@sm": {
    fontSize: theme.sizes.s5,
  },
  transition: "0.3s",
  fontWeight: theme.fontWeights.bold,
  "&:last-child": {
    borderRight: "none",
  },

  variants: {
    tariff: {
      true: {
        color: theme.colors.secondary,
      },
      false: {
        color: theme.colors.primary,
      },
    },
    price: {
      true: {
        width: "auto",
        fontSize: theme.space.s5,
        "@sm": {
          fontSize: theme.space.s7_5,
        },
      },
    },
  },
})
